import { format, parseISO } from 'date-fns';
import React from 'react';
import { CouponScopeTag } from './_components/CouponScopeTag';

// Teto de ciclo aceito no form (a API também deve validar).
export const MAX_COUPON_CYCLE = 120;

export function formatExpiresAt(expiresAt) {
  if (!expiresAt) return 'Sem data de expiração';
  return format(parseISO(expiresAt), 'dd/MM/yyyy');
}

export function formatCycleRange(fromCycle, toCycle) {
  const from = fromCycle == null ? 1 : Number(fromCycle);
  if (toCycle === null || toCycle === undefined || toCycle === '') {
    return from <= 1 ? 'Todos os ciclos' : `A partir do ciclo ${from}`;
  }
  const to = Number(toCycle);
  return `De ${from} até ${to}`;
}

// Regra vale no ciclo? toCycle vazio = sem fim. Aceita o shape do form ('' )
// e o da API (null/undefined).
export function ruleActiveAtCycle(rule, cycle) {
  const from =
    rule.fromCycle == null || rule.fromCycle === '' ? 1 : Number(rule.fromCycle);
  const to =
    rule.toCycle == null || rule.toCycle === ''
      ? Infinity
      : Number(rule.toCycle);
  return from <= cycle && cycle <= to;
}

// Regra PLAN de outro plano não vale pra oferta desse plano.
export function ruleMatchesPlan(rule, planId) {
  return rule.scope !== 'PLAN' || !rule.planId || rule.planId === planId;
}

// Regra ITEM com itemId só vale pra linha daquele item; sem itemId vale pra todas.
export function ruleMatchesItem(rule, itemId) {
  return rule.scope !== 'ITEM' || !rule.itemId || rule.itemId === itemId;
}

// Regra com planId/itemId é específica daquele plano/produto; as demais valem
// pra todos.
export function isSpecificRule(rule) {
  return (
    (rule.scope === 'PLAN' && !!rule.planId) ||
    (rule.scope === 'ITEM' && !!rule.itemId)
  );
}

// Um grupo por plano/produto específico: regras compartilhadas + as dele, na
// ordem original. `rule` é a primeira específica (dá o nome do grupo). Sem
// regra específica devolve [].
// ponytail: plano × produto não é cruzado — grupos de plano e de produto são
// independentes.
export function groupRulesByTarget(rules) {
  const keyOf = (rule) =>
    `${rule.scope}:${rule.scope === 'PLAN' ? rule.planId : rule.itemId}`;
  const keys = [...new Set(rules.filter(isSpecificRule).map(keyOf))];
  return keys.map((key) => ({
    key,
    rule: rules.find((rule) => isSpecificRule(rule) && keyOf(rule) === key),
    rules: rules.filter((rule) => !isSpecificRule(rule) || keyOf(rule) === key),
  }));
}

export function formatCouponCode(value) {
  return (value || '')
    .toString()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toUpperCase()
    .replace(/\s+/g, '_')
    .replace(/[^A-Z0-9_-]/g, '');
}

export function formatAppliesTo(coupon) {
  const scopes = [...new Set((coupon?.rules ?? []).map((rule) => rule.scope))];
  if (!scopes.length) {
    return '-';
  }
  return (
    <div className="d-flex flex-wrap" style={{ gap: '4px' }}>
      {scopes.map((scope) => (
        <CouponScopeTag key={scope} scope={scope} />
      ))}
    </div>
  );
}

// Valor de uma regra (rule) de desconto — %/R$ — não confundir com
// formatDiscount, que lê um valor plano no próprio cupom (formato legado).
// O "−" deixa claro que é desconto, não o valor cobrado.
export function formatRuleValue(rule) {
  const value = rule.value;
  const valueType = rule.valueType ?? rule.value_type;
  if (value === undefined || value === null || value === '') return '-';
  return valueType === 'PERCENT'
    ? `−${value}%`
    : `−R$ ${Number(value).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      })}`;
}

export function formatDiscount(coupon) {
  const value = coupon.discountValue ?? coupon.value;
  const valueType = coupon.discountValueType ?? coupon.valueType;
  if (value === undefined || value === null) return '-';
  return valueType === 'PERCENT' ? `${value}%` : `R$${value}`;
}

export function getInitialParams(search) {
  const params = new URLSearchParams(search);
  const page = Number(params.get('page')) || 1;
  const perPage = Number(params.get('perPage')) || 10;
  const code = params.get('code') || '';
  const activeOnly = params.get('active') !== 'false';
  return { page, perPage, code, activeOnly };
}
